import { updateMarkers, destroy, init } from "./map";

jQuery(function ($) {
    const updateRoomList = () => {
        let form_data = [];
        form_data.push({ name: 'action', value: 'room_list' });
        form_data.push({ name: 'ofmovingindate', value: $('[name="ofmovingindate"]').val() });
        form_data.push({ name: 'oflocations', value: $('[name="oflocations"]').val() });
        form_data.push({ name: 'ofpricerange', value: $('[name="ofpricerange"]').val() });
        form_data.push({ name: 'ofproperty-types', value: $('[name="ofproperty-types"]').val() });
        form_data.push({ name: 'status', value: $('[name="status"]').val() });
        form_data.push({ name: 'paged', value: $('[name="paged"]').val() });

        // Update the URL get parameters with all the values above, except action and blog-id
        const params = new URLSearchParams(window.location.search);
        
        // Add new parameters from form data
        form_data.forEach(item => {
            if (item.name !== 'action') {
                const value = item.value;
                if (value !== undefined && value !== null && value !== '' && value !== '0') {
                    params.set(item.name, value);
                } else {
                    params.delete(item.name);
                }
            }
        });
        
        // Update the URL without page reload
        if (window.history && window.history.replaceState) {
            const baseUrl = theme.url + '/listings/';
            const search = params.toString() ? `?${params.toString()}` : '';
            const hash = window.location.hash || '';
            const newUrl = `${baseUrl}${search}${hash}`;
            window.history.replaceState({}, '', newUrl);
        }

        $.ajax({
            type: 'get',
            url: theme.ajaxurl,
            dataType: 'json',
            data: form_data,
            beforeSend: function () {
                $('.listing-search button[type="submit"]').addClass('loading');
                $('.roomlist > *:not(.rooms-grid.loading)').remove();
                $('.roomlist > .rooms-grid.loading').removeClass('hidden');
            },
            success: function (response) {
                const $roomList = $('.roomlist');
                $roomList.html($(response.html).html());
                window.statuses = response.statuses;
                updateMarkers($(response.markers).filter('.marker'));
                // destroy();
                // $('.acf-map').html(response.markers);
                // init();
            },
            error: function (response) {
                console.log(response);
            },
            complete: function () {
                $('.listing-search button[type="submit"]').removeClass('loading');
                $('.listing-search .close-filter').trigger('click');
            }
        });
    }
    
    $('.listing-search button[type="submit"]').on('click', function () {
        $(this).addClass('loading');
    });

    if($('body.post-type-archive-listing, body.tax-property-types, body.tax-locations, body.tax-pricerange').length > 0) {
        updateRoomList();

        $('.listing-search button[type="submit"]').on('click', function (e) {
            e.preventDefault();
            $('[name="paged"]').val(1);
            updateRoomList();
        });
    }

    $(document).on('click', '.update-room-list-status', function (e) {
        e.preventDefault();
        const status = $(this).data('status');
        $(`.update-room-list-status:not([data-status="${status}"])`).removeClass('active');
        $(this).addClass('active');
        $('[name="status"]').val(status);
        $('[name="paged"]').val(1);

        updateRoomList(status);
    });

    $(document).on('click', '.roomlist .pagination .page-numbers', function (e) {
        e.preventDefault();
        const href = $(this).attr('href');
        if (!href) return;
        const match = href.match(/[?&]paged=(\d+)/);
        const page = match ? match[1] : 1;
        $('[name="paged"]').val(page);
        $('html,body').animate({ scrollTop: 0 }, 500, 'swing');
        updateRoomList();
    });
});